module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/dash-board/shoppingcart/payment-receipt-store/payment-receipt-store.component.css
// module id = ./src/app/dash-board/shoppingcart/payment-receipt-store/payment-receipt-store.component.css
// module chunks = main